import Alpine from "alpinejs";

Alpine.data("quantitySelector", () => ({
  get variant() {
    return Alpine.store("variant");
  },
  get min() {
    let _min = this.variant.stock?.inventory_management === "shopify" 
      ? this.variant.quantity_rule?.min
      : 1;
      
    return _min || 1;
  },
  get max() {
    let _max = this.variant.stock?.inventory_management === "shopify"
      ? this.variant.quantity_rule?.max
      : 9999;

    return _max || 9999;
  },
  get increment() {
    return this.variant.quantity_rule?.increment || 1;
  },
  quantity: 1,
  incrementQuantity() {
    if (this.quantity < this.max) {
      this.quantity += this.increment;
    }
  },
  decrementQuantity() {
    if (this.quantity > this.min) {
      this.quantity -= this.increment;
    }
  },

  get totalPrice() {
    return this.variant.price * this.quantity;
  },
}));
